export default {
	setFields(state, data) {
		let newData = Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value === null ? 0 : value]));
		state.fields = newData;
	},
	setField(state, data) {
		state.fields[data.fieldName] = data.newVal;
	},
	setErrors(state, data) {
		state.errors = data;
	},
	setError(state, data) {
		state.errors[data.fieldName] = data.newVal;
	},
	clearErrors(state) {
		state.errors = {};
	},
};
